import { render, staticRenderFns } from "./LinhasTabelas.vue?vue&type=template&id=38ceb12e"
import script from "./LinhasTabelas.vue?vue&type=script&lang=js"
export * from "./LinhasTabelas.vue?vue&type=script&lang=js"
import style0 from "./LinhasTabelas.vue?vue&type=style&index=0&id=38ceb12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports